// src/components/PrivateRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAuthStore from '../stores/useAuthStore' // Doğru yolu kontrol edin

interface PrivateRouteProps {
  requiredRole?: 'admin';
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ requiredRole }) => {
  const { isLoggedIn, adminInfo } = useAuthStore();

  // Kullanıcı giriş yapmamışsa, login sayfasına yönlendir
  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  // Eğer belirli bir rol (örneğin admin) gerekiyorsa, kontrol et
  if (requiredRole === 'admin' && (!adminInfo || !adminInfo.isAdmin)) {
    return <Navigate to="/home" replace />;
  }

  // Giriş yapılmış ve varsa rol şartı da sağlanmışsa, Outlet üzerinden alt bileşenleri render et
  return <Outlet />;
};

export default PrivateRoute;
